/* unplugin-vue-components disabled */import { render } from "./navbar.vue?vue&type=template&id=622238e2"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbar/navbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "622238e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('622238e2', __exports__)) {
    api.reload('622238e2', __exports__)
  }
  
  module.hot.accept("./navbar.vue?vue&type=template&id=622238e2", () => {
    api.rerender('622238e2', render)
  })

}


export default __exports__